import { Heading, Skeleton, useToast } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { errorToastConfig } from 'packages/common-frontend/constants';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { PortfolioStatementsExpensesFeesChart } from 'packages/portfolio/ui/statements/PortfolioStatementsExpensesFeesChart';
import { useGetLedgerAccountsQuery } from 'packages/statements/requests/ledger.gql.generated';

export const InsightsExpensesFeesContainerV2 = () => {
  const toast = useToast();
  const { creditFacilityId } = useCreditFacilityContext();

  const {
    data: ledgerAccountsData,
    loading: isLedgerAccountsLoading,
  } = useGetLedgerAccountsQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
    variables: {
      creditFacilityId,
      ledgerAccountGroup: 'expensesFees',
    },
  });

  if (!ledgerAccountsData || isLedgerAccountsLoading) {
    return <Skeleton data-testid="loading-insights-view" height="600px" />;
  }

  const countersignerOrganizationIds = _.map(
    ledgerAccountsData.ledgerAccounts,
    (account) => account.organizationId,
  );
  return (
    <>
      <Heading as="h2" fontSize="2xl" mb="20px">
        Expenses &amp; Fees
      </Heading>
      <PortfolioStatementsExpensesFeesChart
        accounts={ledgerAccountsData.ledgerAccounts}
        creditFacilityId={creditFacilityId}
        organizationIds={countersignerOrganizationIds}
        chartTitle="Expenses & Fees"
      />
    </>
  );
};
